module.exports = __webpack_public_path__ + "img/mc_w.f1d528ae.png";